import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS,
  markupDescription
} from './../utils';

const behaviourFields = [
  {
    label: 'Button Action',
    name: 'action',
    editor: 'dropdown',
    default: '',
    description: 'An action to run when this button is clicked',
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },

    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Action Running Text',
    name: 'actionRunningText',
    editor: 'textbox',
    default: '',
    description:
      'Alternative text to display when the action sequencer is running',
    options: [],
    displayWhen: [{ field: 'action', operator: 'IS_NOT_EMPTY', value: '' }],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Use Non-Theme Button',
    name: 'useNonThemeButton',
    editor: 'boolean',
    description: 'If true will customise the button different to the theme',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Disabled',
    name: 'disabled',
    editor: 'boolean',
    description: 'If the button should be disabled by default',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Disable When Screen Invalid',
    name: 'disableWhenScreenInvalid',
    editor: 'boolean',
    description: 'If the button will be disabled if the screen is invalid',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  }
];

const contentFields = [
  'text',
  {
    label: 'Use Data Binding for Button Text',
    name: 'useDataBinding',
    type: 'boolean',
    default: false,
    description:
      'If true, this text on the button can be dynamically displayed from data being viewed.',
    editor: 'switch',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Source',
    name: 'datasourceId',
    description: 'Choose a content type this element will get its data from',
    editor: 'dropdown',
    function: {
      name: 'getDynamicDataSources',
      params: ['app.id']
    },
    default: '',
    displayWhen: [{ field: 'useDataBinding', operator: '==', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Field',
    name: 'sourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying datasource will be used as the value of this element',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      values: [],
      params: ['app.id', 'element.datasourceId']
    },
    displayWhen: [{ field: 'useDataBinding', operator: '==', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Markup',
    name: 'datasourceFieldMarkup',
    editor: 'textbox',
    description: markupDescription,
    default: '',
    options: [],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  }
];

const layoutFields = [
  {
    label: 'Margin',
    name: 'margin',
    editor: 'boundary',
    description: 'Margin around the button',
    default: '20 20 20 20',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Padding',
    name: 'padding',
    editor: 'boundary',
    description: 'Padding within the button',
    default: '10 0 10 0',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  'alignment',
  'layout',
  {
    label: 'Button Mode',
    name: 'mode',
    editor: 'dropdown',
    default: 'text',
    description: 'The mode of button',
    options: [
      {
        label: 'Text',
        value: 'text'
      },
      {
        label: 'Outlined',
        value: 'outlined'
      },
      {
        label: 'Contained',
        value: 'contained'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Border Radius',
    name: 'borderRadius',
    editor: 'number',
    description: 'The border radius of the element',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Border Width',
    name: 'borderWidth',
    editor: 'number',
    description: 'The border width of the element',
    default: 0,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Border Style',
    name: 'borderStyle',
    editor: 'dropdown',
    description: 'The border style of the buton',
    default: 'solid',
    options: [
      { label: 'Solid', value: 'solid' },
      { label: 'Dotted', value: 'dotted' },
      { label: 'Dashed', value: 'dashed' }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Width',
    name: 'width',
    editor: 'number',
    description: 'The width of the button',
    default: 245,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    name: 'buttonTextAlignment',
    label: 'Button Text Alignment',
    description: '',
    editor: 'alignment',
    type: 'string',
    default: 'justify-center',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    name: 'iconMargin',
    label: 'Icon Margin',
    description: '',
    editor: 'boundary',
    type: 'string',
    default: '0 10 0 0',
    displayWhen: [{ field: 'showIcon', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  }
];

const colorFields = [
  {
    name: 'disabledBackgroundColor',
    label: 'Disabled Background Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#182fa4',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Border Color',
    name: 'borderColor',
    editor: 'color',
    description: 'The border color of a list item',
    default: '#182fa4',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },

  {
    name: 'color',
    label: 'Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#ffffff',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'backgroundColor',
    label: 'Background Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#182fa4',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    name: 'disabledColor',
    label: 'Disabled Color',
    description: '',
    editor: 'color',
    type: 'string',
    default: '#ffffff',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  }
];

const imageFields = [
  {
    label: 'Show Icon',
    name: 'showIcon',
    editor: 'boolean',
    description: 'If the button should include an icon',
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Show Icon After',
    name: 'showIconAfter',
    editor: 'boolean',
    default: false,
    description: 'Shows the icon after the button text',
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Render as Image',
    name: 'renderAsImage',
    editor: 'boolean',
    default: false,
    description:
      'Displays a pressable image for the button instead of a standard button',
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Button Image',
    name: 'buttonImage',
    editor: 'image',
    default: false,
    description: 'The image to use for the button',
    mediaLibraryPath: 'apps',
    mediaLibraryStoreIn: 'custom_folder',
    displayWhen: [{ field: 'renderAsImage', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Buttom Image Mode',
    name: 'buttonImageMode',
    editor: 'dropdown',
    description: 'The resize option of the button image.',
    default: 'cover',
    options: [
      { label: 'Cover', value: 'cover' },
      { label: 'Contain', value: 'contain' }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Buttom Image Width',
    name: 'buttonImageWidth',
    editor: 'number',
    description: 'The width of the button image',
    default: 320,
    displayWhen: [{ field: 'renderAsImage', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Buttom Image Height',
    name: 'buttonImageHeight',
    editor: 'number',
    description: 'The height of the button image',
    default: 245,
    displayWhen: [{ field: 'renderAsImage', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    label: 'Icon',
    name: 'icon',
    editor: 'icon',
    description: 'The button icon',
    displayWhen: [{ field: 'showIcon', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  },
  {
    name: 'iconsize',
    label: 'Icon Size',
    description: '',
    editor: 'iconsize',
    type: 'number',
    default: 6,
    displayWhen: [{ field: 'showIcon', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
  }
];

const fontFields = ['font', 'fontFamily'];

const ButtonElementFields = {
  group: ELEMENT_GROUPS.NAVIGATION,
  label: 'Button',
  icon: 'PhotographIcon',
  description: 'Add a button to the screen',
  properties: [
    ...behaviourFields,
    ...contentFields,
    ...layoutFields,
    ...colorFields,
    ...imageFields,
    ...fontFields
  ]
};

export default ButtonElementFields;
